<template>
  <v-container fluid>
    <v-row>
      <v-col class="custom-content-container pt-0" cols="12" md="9" sm="9">
        <v-row>
          <v-col md="12">
            <v-row>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Salutation</label
                  >
                  <v-select
                    v-model.trim="personalInfo.title"
                    :items="salutationList"
                    dense
                    filled
                    :rules="[
                      validateRules.required(personalInfo.title, 'Title'),
                    ]"
                    item-text="text"
                    item-value="value"
                    item-color="cyan"
                    placeholder="Salutation"
                    solo
                    flat
                    color="cyan"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >First name</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.first_name"
                    :rules="[
                      validateRules.required(
                        personalInfo.first_name,
                        'First name'
                      ),
                      validateRules.minLength(
                        personalInfo.first_name,
                        'First name',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.first_name,
                        'First name',
                        50
                      ),
                    ]"
                    dense
                    filled
                    placeholder="First name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16">Last name</label>
                  <v-text-field
                    v-model.trim="personalInfo.last_name"
                    :rules="[
                      validateRules.minLength(
                        personalInfo.last_name,
                        'Last name',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.last_name,
                        'Last name',
                        50
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Last name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Display name</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.display_name"
                    :rules="[
                      validateRules.required(
                        personalInfo.display_name,
                        'Display name'
                      ),
                      validateRules.minLength(
                        personalInfo.display_name,
                        'Display name',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.display_name,
                        'Display name',
                        50
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Display name"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
               <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Username</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.user_name"
                    :rules="[
                      validateRules.required(
                        personalInfo.user_name,
                        'Username'
                      ),
                      validateRules.minLength(
                        personalInfo.user_name,
                        'Username',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.user_name,
                        'Username',
                        50
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Username"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required">
                    Designation</label
                  >
                  <v-autocomplete
                    :items="engineerDesignations"
                    dense.
                    filled
                    color="cyan"
                    item-color="cyan"
                    solo
                    flat
                    v-model.trim="personalInfo.designation"
                    append-outer-icon="mdi-cog"
                    placeholder="Select Designation"
                    v-on:click:append-outer="Designationdata"
                    item-text="text"
                    item-value="value"
                    class="width-100 new-height"
                    hide-details
                    :rules="[
                      validateRules.required(
                        personalInfo.designation,
                        'Designationdata'
                      ),
                    ]"
                  >
                    <template v-slot:no-data>
                      <v-list-item>
                        <v-list-item-content>
                          <v-list-item-title
                            v-html="'No Designation(s) Found.'"
                          ></v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-autocomplete>

                  <template>
                    <ManageEdesignation
                      :d-dialog="manageBrandDialog"
                      :e_designation="engineerDesignations"
                      v-on:close-dialog="manageBrandDialog = false"
                      :exist-category="personalInfo.designation"
                      v-on:get-e-designation="getOptions"
                    ></ManageEdesignation>
                  </template>

                  <!-- <v-select
                    :items="engineerDesignations"
                    v-model.trim="personalInfo.designation"
                    :rules="[
                      validateRules.required(
                        personalInfo.designation,
                        'Designation'
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Designation"
                    solo
                    flat
                    item-color="cyan"
                    item-text="title"
                    item-value="value"
                  ></v-select> -->
                </template>
              </v-col>
              <v-col md="6" class="py-0" v-if="false">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Skills</label
                  >
                  <v-select
                    :items="engineerSkills"
                    v-model.trim="personalInfo.skills"
                    :rules="[
                      validateRules.required(personalInfo.skills, 'Skills'),
                    ]"
                    dense
                    filled
                    placeholder="Skills"
                    solo
                    flat
                    item-color="cyan"
                    item-text="title"
                    item-value="value"
                    multiple
                  ></v-select>
                </template>
              </v-col>
              <v-col :md="allowZones ? 6 : 12" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Email address</label
                  >
                  <v-text-field
                    v-model.trim="personalInfo.primary_email"
                    :rules="[
                      validateRules.required(
                        personalInfo.primary_email,
                        'Email address'
                      ),
                      validateRules.validEmail(
                        personalInfo.primary_email,
                        'Email address'
                      ),
                      validateRules.minLength(
                        personalInfo.primary_email,
                        'Email address',
                        1
                      ),
                      validateRules.maxLength(
                        personalInfo.primary_email,
                        'Email address',
                        50
                      ),
                    ]"
                    dense
                    filled
                    placeholder="Email address"
                    solo
                    flat
                  ></v-text-field>
                </template>
              </v-col>
              <v-col md="6" class="py-0" v-if="allowZones">
                <label class="font-weight-700 font-size-16">
                  Zone Territory</label
                >
                <v-autocomplete
                  :items="zoneList"
                  dense.
                  filled
                  color="cyan"
                  item-color="cyan"
                  solo
                  flat
                  v-model.trim="personalInfo.zone_territory"
                  placeholder="Select Zone"
                  item-text="name"
                  item-value="name"
                  class="width-100 new-height"
                  hide-details
                  multiple
                >
                  <template v-slot:no-data>
                    <v-list-item>
                      <v-list-item-content>
                        <v-list-item-title
                          v-html="'No Zone(s) Found.'"
                        ></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Phone number</label
                  >
                  <PhoneTextField
                    id="primary_phone"
                    v-model="personalInfo.primary_phone"
                    :value="personalInfo.primary_phone"
                    required
                  >
                  </PhoneTextField>
                </template>
              </v-col>
              <v-col md="6" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16 required"
                    >Role</label
                  >

                  <v-select
                    :items="roles"
                    v-model.trim="personalInfo.role"
                    :rules="[validateRules.required(personalInfo.role, 'Role')]"
                    dense
                    filled
                    placeholder="Role"
                    solo
                    flat
                    item-color="cyan"
                    item-text="name"
                    item-value="id"
                  ></v-select>
                </template>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16"
                    >Probation Period
                  </label>
                  <v-select
                    :items="months"
                    v-model.trim="personalInfo.probation_month_number"
                    dense
                    filled
                    placeholder="Probation Month"
                    solo
                    v-on:change="setProbationTime"
                    flat
                    item-color="cyan"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="6" class="py-0" v-if="false">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16">Type</label>
                  <v-select
                    :items="types"
                    v-model.trim="personalInfo.probation_type"
                    dense
                    filled
                    placeholder="Type"
                    solo
                    flat
                    v-on:change="setProbationTime"
                    item-color="cyan"
                    item-text="text"
                    item-value="value"
                  ></v-select>
                </template>
              </v-col>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16"
                    >Probation Start</label
                  >
                  <DatePicker
                    placeholder="Probation Start Date"
                    v-model="personalInfo.probation_start"
                    v-on:change="setProbationTime"
                  />
                </template>
              </v-col>
              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16"
                    >Probation End</label
                  >
                  <div
                    class="font-weight-700"
                    v-if="personalInfo.probation_end"
                  >
                    {{ formatDate(personalInfo.probation_end) }}
                  </div>
                  <div v-else>
                    <em class="text--secondary">No date available</em>
                  </div>
                  <!-- <DatePicker
                    :minDate="personalInfo.probation_start"
                    placeholder="Probation End Date"
                    v-model="personalInfo.probation_end"
                  /> -->
                </template>
              </v-col>

              <!-- start addding new fields -->
             <!--  <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16">FIN No</label>
                  <v-text-field
                    v-model="personalInfo.fin_no"
                    dense
                    filled
                    placeholder="FIN No"
                    solo
                    flat
                    type="text"
                  ></v-text-field>
                 
                </template>
              </v-col>

              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16"
                    >WP Expired Date</label
                  >
                  <DatePicker
                    placeholder="WP Expired Date"
                    v-model="personalInfo.wp_expired_date"
                    v-on:change="setWpExipryDate"
                  />
                </template>
              </v-col>

              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16"
                    >Vehicle No.</label
                  >
                  <v-text-field
                    v-model="personalInfo.vehicle_no"
                    dense
                    filled
                    placeholder="Vehicle No."
                    solo
                    flat
                    type="text"
                  ></v-text-field>
                </template>
              </v-col>

              <v-col md="4" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <template v-else>
                  <label class="font-weight-700 font-size-16">IU No.</label>
                  <v-text-field
                    v-model="personalInfo.iu_no"
                    dense
                    filled
                    placeholder="IU No."
                    solo
                    flat
                    type="text"
                  ></v-text-field>
                </template>
              </v-col> -->
              <!-- end addding new fields -->
            </v-row>
            <v-row v-if="false">
              <v-col md="6" class="py-0">
                <div class="text-h6 font-weight-700 my-2">
                  Default Retention period
                </div>
                <div class="ps-6">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <label class="font-weight-700 font-size-16"
                      >Retention Period:</label
                    >
                    <v-row>
                      <v-col md="3" class="py-0">
                        <v-text-field
                          v-model="personalInfo.retention_period"
                          dense
                          filled
                          placeholder="Retention Period"
                          solo
                          flat
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4" class="pt-0">
                        <v-text-field
                          v-model="personalInfo.period"
                          dense
                          filled
                          placeholder="Days"
                          type="text"
                          solo
                          flat
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>

                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <template v-else>
                    <div class="d-flex align-center w-75">
                      <label class="font-weight-700 font-size-16 me-15"
                        >Automatic Deletion Period:</label
                      >
                      <v-spacer></v-spacer>
                      <v-checkbox
                        class="mt-0 me-15 pe-11"
                        color="blue"
                        readonly
                        hide-details
                        v-model.trim="personalInfo.automatic_deletion_period"
                      />
                      <!-- <v-chip class="ms-15" outlined color="grey">
                        <v-icon class="me-2" color="blue" size="20"
                          >mdi-circle</v-icon
                        >
                        <span class="font-weight-700 font-size-16">ON</span>
                      </v-chip> -->
                    </div>
                    <v-row>
                      <v-col md="3">
                        <v-text-field
                          v-model="personalInfo.deletion_period"
                          dense
                          filled
                          placeholder="Deletion Period"
                          solo
                          flat
                          type="number"
                        ></v-text-field>
                      </v-col>
                      <v-col md="4">
                        <v-text-field
                          v-model="personalInfo.period"
                          dense
                          filled
                          placeholder="Days"
                          type="text"
                          solo
                          flat
                          readonly
                        ></v-text-field>
                      </v-col>
                    </v-row>
                  </template>
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0">
              <v-col md="6" class="py-0 mt-2 mb-2">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    v-if="false"
                    color="blue"
                    :readonly="true"
                    :label="getLabel()"
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.email_notification"
                  />
                  <!-- <v-switch
                    v-else
                    v-model.trim="personalInfo.email_notification"
                    inset
                    :value="1"
                    color="red"
                    hide-details
                    label="Activation email will be sent to the user"
                    class="mt-0"
                  ></v-switch> -->
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0">
              <v-col md="6" class="py-0 mt-2 mb-4">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    v-if="false"
                    color="blue"
                    label="
                      Force user to change password on first log in
                    "
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.force_password_change"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row v-if="personalInfo.can_login && engineerId == 0 && false">
              <v-col md="6" class="py-0 mt-2 mb-4">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>

                  <v-checkbox
                    color="blue"
                    label="
                      Default Retention period
                    "
                    :input-value="1"
                    :true-value="1"
                    :false-value="0"
                    hide-details
                    class="mt-0"
                    v-model.trim="personalInfo.default_retention_period"
                  />
                </div>
              </v-col>
            </v-row>
            <v-row>
              <v-col md="6" class="py-0">
                <div class="d-flex">
                  <template v-if="updateEngineer && pageLoading">
                    <v-skeleton-loader
                      class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                      type="text"
                    >
                    </v-skeleton-loader>
                  </template>
                  <v-switch
                    v-else
                    v-model.trim="personalInfo.can_login"
                    inset
                    :value="1"
                    color="cyan"
                    hide-details
                    label="Allow Login"
                    class="mt-0"
                  ></v-switch>
                </div>
              </v-col>
              <v-col v-if="false" md="6" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <v-switch
                  v-else
                  v-model.trim="personalInfo.allow_leave"
                  inset
                  :value="1"
                  color="cyan"
                  hide-details
                  label="Allow Leave"
                  class="mt-0"
                ></v-switch>
              </v-col>
              <v-col md="6" class="py-0">
                <template v-if="updateEngineer && pageLoading">
                  <v-skeleton-loader
                    class="custom-skeleton my-2 custom-text-width-100px custom-text-height-40px"
                    type="text"
                  >
                  </v-skeleton-loader>
                </template>
                <v-switch
                  v-else
                  v-model.trim="personalInfo.is_manager"
                  inset
                  :value="1"
                  color="cyan"
                  hide-details
                  label="Is Project Manager"
                  class="mt-0"
                ></v-switch>
                <!-- <v-switch
                  v-else
                  v-model.trim="personalInfo.is_driver"
                  inset
                  :value="1"
                  color="cyan"
                  hide-details
                  placeholder="Is Driver"
                  class="mt-0"
                ></v-switch> -->
              </v-col>
              <!-- <v-col
                md="12"
                class="py-4"
                v-if="personalInfo.allow_leave == 1 && leaveTypes.length"
              >
                <table width="100%">
                  <tbody>
                    <tr v-for="(row, index) in leaveTypes" :key="index">
                      <td
                        class="font-size-16 font-weight-600 px-2 py-4"
                        valign="middle"
                      >
                        {{ row.title }}
                      </td>
                      <td class="py-2">
                        <v-text-field
                          v-model.trim="personalInfo.engineerLeaves[row.value]"
                          v-mask="'###'"
                          dense
                          hide-details
                          filled
                          :label="row.title"
                          solo
                          flat
                        ></v-text-field>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </v-col> -->
            </v-row>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="custom-sidebar-container white lighten-3 text-center"
        cols="12"
        md="3"
        sm="3"
      >
        <div class="text-center">
          <template v-if="updateEngineer && pageLoading">
            <v-skeleton-loader
              class="custom-skeleton custom-avatar-100px"
              type="avatar"
            >
            </v-skeleton-loader>
          </template>
          <template v-else>
            <v-progress-circular
              indeterminate
              :size="100"
              :width="10"
              color="cyan"
              v-if="primaryLoader"
            ></v-progress-circular>
            <v-img
              v-else
              :lazy-src="$defaultProfileImage"
              :src="getProfileImage ? getProfileImage : $defaultProfileImage"
              max-height="200"
              max-width="200"
              height="140px"
              width="140px"
              class="custom-grey-border custom-border-radius-50 mx-auto"
            >
            </v-img>
          </template>
        </div>
        <div class="py-5 text-center">
          <template v-if="updateEngineer && pageLoading">
            <v-skeleton-loader
              class="mx-4 custom-skeleton small-skeleton-action-button"
              type="button"
            >
            </v-skeleton-loader>
          </template>
          <v-btn
            v-else
            class="mx-4 custom-bold-button"
            outlined
            small
            :disabled="primaryLoader"
            :loading="primaryLoader"
            v-on:click="selectImage"
            color="cyan"
          >
            <template v-if="personalInfo.profile_image">Change Image</template>
            <template v-else>Upload Image</template>
          </v-btn>
          <div class="d-none">
            <v-file-input
              v-model.trim="rawImage"
              ref="uploadImage"
              :rules="imageRules"
              accept="image/png, image/jpeg, image/bmp"
            ></v-file-input>
          </div>
        </div>
        <template v-if="false">
          <template v-for="(fieldInfo, indx) in fieldDescriptions">
            <div
              v-if="fieldInfo.field == currentActiveField"
              :key="indx"
              class="help-sidebar"
            >
              <div class="help-sidebar-header">
                <h3 v-if="fieldInfo.title" class="section-header-title">
                  {{ fieldInfo.title }}
                </h3>
              </div>
              <p v-if="fieldInfo.description" class="help-sidebar-description">
                {{ fieldInfo.description }}
              </p>
              <h5 v-if="fieldInfo.footer" class="help-sidebar-footer-title">
                {{ fieldInfo.footer }}
              </h5>
              <p
                v-if="fieldInfo.footer_content"
                class="help-sidebar-footer-text"
              >
                {{ fieldInfo.footer_content }}
              </p>
            </div>
          </template>
        </template>
      </v-col>
    </v-row>
  </v-container>
</template>
<style scoped>
.v-text-field--filled > .v-input__control > .v-input__slot {
  min-height: 100%;
}
.v-input input {
  max-height: 30px;
}
</style>
<script>
import ManageEdesignation from "@/view/pages/partials/Manage-Edesignation.vue";
import CommonMixin from "@/core/plugins/common-mixin";
import { EngineerEventBus } from "@/core/lib/engineer/engineer.lib";
import ValidationMixin from "@/core/plugins/validation-mixin";
import FileManagerMixin from "@/core/lib/file-manager/file.manager.mixin";
import { GET } from "@/core/services/store/request.module";
import PhoneTextField from "@/view/pages/partials/PhoneTextField";
import DatePicker from "@/view/components/QDatePicker.vue";
import moment from "moment-timezone";

moment.tz.setDefault(process.env.VUE_APP_TIMEZONE);

export default {
  name: "personal-info",
  mixins: [ValidationMixin, CommonMixin, FileManagerMixin],
  props: {
    pageLoading: {
      type: Boolean,
      default: false,
    },
    updateEngineer: {
      type: Boolean,
      default: false,
    },
    engineer: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      allowZones: 0,
      engineerId: 0,
      zoneList: [],
      engineerSkills: [],
      manageBrandDialog: false,
      engineerDesignations: [],
      e_designation: [],
      leaveTypes: [],
      timeoutLimit: 100,
      roles: [],
      months: [
        { value: 1, text: "1 (Month)" },
        { value: 2, text: "2 (Month)" },
        { value: 3, text: "3 (Month)" },
        { value: 4, text: "4 (Month)" },
        { value: 5, text: "5 (Month)" },
        { value: 6, text: "6 (Month)" },
        { value: 7, text: "7 (Month)" },
        { value: 8, text: "8 (Month)" },
        { value: 9, text: "9 (Month)" },
        { value: 10, text: "10 (Month)" },
        { value: 11, text: "11 (Month)" },
        { value: 12, text: "12 (Month)" },
      ],
      types: [{ value: "month", text: "Month" }],
      timeout: null,
      personalInfo: {
        profile_image: null,
        probation_start: null,
        probation_end: null,
        probation_month_number: null,
        probation_type: "month",
        title: "mr",
        first_name: null,
        last_name: null,
        display_name: null,
        designation: 0,
        primary_email: null,
        primary_phone: null,
        user_name: null,
        engineerLeaves: {},
        // adding new columns
        iu_no: null,
        wp_expired_date: null,
        fin_no: null,
        vehicle_no: null,

        skills: [],
        leave: null,
        can_login: 1,
        email_notification: 1,
        allow_leave: 0,
        is_driver: 0,
        is_manager: 0,
        role: 0,
        zone_territory: [],
        retention_period: null,
        deletion_period: null,
        period: "Days",
        force_password_change: 1,
        default_retention_period: 1,
        automatic_deletion_period: true,
      },
      rawImage: null,
      fieldDescriptions: [],
    };
  },
  watch: {
    "personalInfo.first_name"() {
      this.personalInfo.display_name =
        (this.personalInfo.first_name || "") +
        " " +
        (this.personalInfo.last_name || "");
    },
    "personalInfo.last_name"() {
      this.personalInfo.display_name =
        (this.personalInfo.first_name || "") +
        " " +
        (this.personalInfo.last_name || "");
    },
    rawImage(param) {
      const _this = this;
      _this.uploadAttachment(param).then((response) => {
        _this.personalInfo.profile_image = _this.lodash.head(response);
      });
    },
    personalInfo: {
      deep: true,
      immediate: true,
      handler(param) {
        console.log("param", param);

        const _this = this;
        clearTimeout(_this.timeout);
        _this.timeout = setTimeout(function () {
          EngineerEventBus.$emit("update:personal-info", param);
        }, _this.timeoutLimit);
      },
    },
    engineer() {
      this.setPersonalInfo();
    },
  },
  methods: {
    getLabel() {
      return `Credentials to be sent to user via email ${
        this.personalInfo?.primary_email
          ? this.personalInfo?.primary_email
          : ".....@gmail.com"
      }`;
    },
    setProbationTime() {
      if (this.personalInfo && this.personalInfo.probation_start) {
        let date = moment(this.personalInfo.probation_start, "YYYY-MM-DD");
        if (
          this.personalInfo.probation_month_number &&
          this.personalInfo.probation_type
        ) {
          date.add(this.personalInfo.probation_month_number, "M");

          date.subtract(1, "days");
        }
        this.personalInfo.probation_end = date.format("YYYY-MM-DD");
      }
    },
    setWpExipryDate() {
      if (this.personalInfo && this.personalInfo.wp_expiry_date) {
        let date = moment(this.personalInfo.wp_expiry_date, "DD-MM-YYYY");

        this.personalInfo.wp_expiry_date = date.format("DD-MM-YYYY");
      }
    },
    Designationdata() {
      this.manageBrandDialog = true;
      this.getOptions();
    },
    getRolesNew() {
      const _this = this;
      _this.$store
        .dispatch(GET, { url: "user-role-new" })
        .then(({ data }) => {
          _this.roles = data;
          // console.log(_this.roles, "hello");
        })
        .catch((error) => {
          _this.logError(error);
        });
    },

    getOptions() {
      const _this = this;
      _this.$store
        .dispatch(GET, {
          url: "engineer/options",
        })
        .then(({ data }) => {
          this.$emit("barcode", data.barcode);
          _this.engineerDesignations = this.lodash.map(
            data.engineer_designation,
            function (row) {
              return {
                text: row.text,
                value: row.id,
              };
            }
          );
          _this.leaveTypes = this.lodash.map(data.leave_types, function (row) {
            return {
              title: row.value,
              value: row.id,
            };
          });
          _this.engineerSkills = this.lodash.map(data.skills, function (row) {
            return {
              title: row.value,
              value: row.value.toLowerCase(),
            };
          });

          _this.zoneList = data?.active_zones;
          _this.allowZones = data?.allow_zones;
          /*  EngineerEventBus.$emit("update:option:data", data); */
          /*  const _this = this;
          clearTimeout(_this.timeout);
          _this.timeout = setTimeout(function () {
            EngineerEventBus.$emit("update:option:data", data);
          }, _this.timeoutLimit); */
          /*   _this.skillCertificate = this.lodash.map(data.skillCertificate, function (row) {
            return {
              title: row.text,
              value: row.value.toLowerCase(),
            };
          });
          _this.licenseCertificate = this.lodash.map(data.licenseCertificate, function (row) {
            return {
              title: row.text,
              value: row.value.toLowerCase(),
            };
          }); */
        })
        .catch((error) => {
          _this.logError(error);
        });
    },
    selectImage() {
      this.$refs["uploadImage"].$refs["input"].click();
    },
    setPersonalInfo() {
      const _this = this;
      if (_this.lodash.isEmpty(_this.engineer) === false) {
        _this.personalInfo.profile_image = _this.engineer.profile_logo;
        _this.personalInfo.title = _this.engineer.title;
        _this.personalInfo.first_name = _this.engineer.first_name;
        _this.personalInfo.last_name = _this.engineer.last_name;
        _this.personalInfo.role = _this.engineer.role.id;
        _this.personalInfo.display_name = _this.engineer.display_name;
        _this.personalInfo.retention_period = _this.engineer.retention_period;
        _this.personalInfo.deletion_period = _this.engineer.deletion_period;
        if (_this.engineer.designation && _this.engineer.designation.id) {
          _this.personalInfo.designation = _this.engineer.designation.id;
        }
        _this.personalInfo.skills = _this.engineer.skills;

        _this.personalInfo.iu_no = _this.engineer.iu_no;
        _this.personalInfo.wp_expired_date = _this.engineer.wp_expired_date;
        _this.personalInfo.fin_no = _this.engineer.fin_no;
        _this.personalInfo.vehicle_no = _this.engineer.vehicle_no;

        _this.personalInfo.primary_email = _this.engineer.primary_email;
        _this.personalInfo.probation_start = _this.engineer.probation_start;
        _this.personalInfo.probation_end = _this.engineer.probation_end;
        _this.personalInfo.probation_type = _this.engineer.probation_type;
        _this.personalInfo.probation_month_number =
          _this.engineer.probation_month_number;
        _this.personalInfo.primary_phone = _this.engineer.primary_phone;
        _this.personalInfo.user_name = _this.engineer.user_name;
        _this.personalInfo.leave = _this.engineer.leave;
        _this.personalInfo.can_login = +_this.engineer.can_login;
        _this.personalInfo.email_notification =
          +_this.engineer.email_notification;
        _this.personalInfo.allow_leave = +_this.engineer.allow_leave;

        _this.personalInfo.is_driver = +_this.engineer.is_driver;
        _this.personalInfo.is_manager = +_this.engineer.is_manager;
        _this.personalInfo.zone_territory = _this.engineer.zone_territory;
        if (_this.engineer.leaves && _this.engineer.leaves.length > 0) {
          for (let i = 0; i < _this.engineer.leaves.length; i++) {
            const { leave, leave_allowed } = _this.engineer.leaves[i];
            _this.personalInfo.engineerLeaves[leave.id] = leave_allowed;
          }
        }
        _this.personalInfo.force_password_change =
          _this.engineer?.force_password_change;
      }
    },
  },
  computed: {
    getProfileImage() {
      return this.lodash.isEmpty(this.personalInfo.profile_image) === false
        ? this.personalInfo.profile_image.file.url
        : null;
    },
  },
  created() {
    this.engineerId = Number(this.$route?.params?.id ?? 0);
  },
  components: {
    PhoneTextField,
    ManageEdesignation,
    DatePicker,
  },
  mounted() {
    this.setPersonalInfo();
    this.getOptions();
    this.getRolesNew();
  },
};
</script>
